export default function normalizeProcessosCapa(processosCapa, produto = 'IMPORTACAO') {
  const aguardandoChegada = {
    estagio: 'CHEGADA',
    name: 'Aguardando chegada mercadoria',
    accessor: 'aguardandoChegada',
    backgroundColor: '#24517a',
    light: true,
  };

  const aguardandoRegistro = {
    estagio: 'REGISTRO',
    name: 'Aguardando registro mercadoria',
    accessor: 'aguardandoRegistro',
    backgroundColor: '#3378b4',
    light: true,
  };

  const aguardandoDesembaraco = {
    estagio: 'DESEMBARACO',
    name: 'Aguardando desembaraço mercadoria',
    accessor: 'aguardandoDesembaraco',
    backgroundColor: '#9bc1e1',
    light: false,
  };

  const aguardandoAverbacao = {
    estagio: 'AVERBACAO',
    name: 'Aguardando averbação',
    accessor: 'aguardandoAverbacao',
    backgroundColor: '#dbe6f2',
    light: false,
  };

  const aguardandoFaturamento = {
    estagio: 'FATURAMENTO',
    name: 'Aguardando faturamento',
    accessor: 'aguardandoFaturamento',
    backgroundColor: '#dbe6f2',
    light: false,
  };

  const estagiosImportacao = [aguardandoChegada, aguardandoRegistro, aguardandoDesembaraco, aguardandoFaturamento];
  const estagiosExportacao = [aguardandoDesembaraco, aguardandoAverbacao];
  const estagios = produto === 'IMPORTACAO' ? estagiosImportacao : estagiosExportacao;

  return estagios.map((estagio) => {
    const aereo = processosCapa[estagio.accessor]?.aereo || 0;
    const maritimo = processosCapa[estagio.accessor]?.maritimo || 0;
    const rodoviario = processosCapa[estagio.accessor]?.rodoviario || 0;
    const total = aereo + maritimo + rodoviario;

    return {
      total,
      aereo,
      maritimo,
      rodoviario,
      ...estagio,
    };
  });
}
